import { StatusSet } from 'generated-graphql/types';
import { CandidateStatus } from 'services/candidate/types';

const candidateStatusLabelMap = {
  [CandidateStatus.SHORT_LISTED]: 'Shortlisted',
  [CandidateStatus.NOT_PROGRESSING]: 'Not Progressing',
  [CandidateStatus.REJECTED]: 'Rejected',
  [CandidateStatus.REVIEW]: 'Review',
  [CandidateStatus.INTERVIEW_STAGE_1]: '1st Interview Stage',
  [CandidateStatus.INTERVIEW_STAGE_2]: '2nd Interview Stage',
  [CandidateStatus.OFFER]: 'Offer',
  [CandidateStatus.PROGRESSING]: 'Progressing'
};

const defaultCandidateStatusOptions = Object.values(CandidateStatus)
  .sort((a) => {
    if (a === CandidateStatus.SHORT_LISTED) {
      return -1;
    }

    return 0;
  })
  .map((status) => ({
    label: candidateStatusLabelMap[status],
    value: status
  }));

/**
 * @deprecated use modules/analyse/utils/getStatusOptions.ts instead
 */
export const getStatusOptions = ({
  statusSet
}: {
  statusSet: StatusSet | null;
}) => {
  const extraCandidateStatusOptions =
    statusSet?.statuses.map((status) => ({
      label: status.label,
      value: status.value
    })) ?? [];

  return [...defaultCandidateStatusOptions, ...extraCandidateStatusOptions];
};
